module.exports = __webpack_public_path__ + "static/media/popup_layout1.3628558c.svg";